import { DateType } from "./UnmergedRandomResultsReport/DateType"
import { ObservableFromFetch } from "../ObservableFromFetch"

export interface UnmergedRandomResultsReportParams {
  DateFrom: string
  DateTo: string
  DateType: DateType
  CompanyIds: number[]
}

export function UnmergedRandomResultsReportPdf(parameters: UnmergedRandomResultsReportParams) {
  const requestBody: string = JSON.stringify(parameters)

  return ObservableFromFetch<string>("WorkforceReport/UnmergedRandomResultsReport", requestBody)
}
